






import { Component, Vue } from 'vue-property-decorator';
import APP_CONFIG from '../../config';

@Component
export default class FooterBar extends Vue {
    public footerText = APP_CONFIG.FOOTER_TEXT;
}
